import React, { ReactNode, useState } from 'react';
import { BellFilled } from '@ant-design/icons';
import { Breadcrumb, Dropdown, MenuProps } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { IProps } from 'components/Button';
import { useUser } from 'contexts/User';
import { avatar } from 'assets/images';
import pageTitleStore from 'store/pageTitleStore';
import { Link } from 'react-router-dom';

const PageTitle = (): JSX.Element => {
  const title = pageTitleStore((state) => state.title);
  const breadcrumbItems = pageTitleStore((state) => state.breadcrumbItems);
  return (
    <div className="text-primary-50">
      <div className="text-xs my-1.5 flex">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className="font-bold text-2xl">{title}</div>
    </div>
  );
};

export default PageTitle;
